<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-alert  color="warning" title="คำแนะนำ" close-icon="icon-x" icon="icon-info" icon-pack="feather">
            <p>{{ receivedSuggestion }}
              <vs-button color="success" type="filled" icon-pack="feather" icon="icon-check"  class="btn-icon float-right"  v-if="callHistoriesReceivedStatus === IStatus.disabled"  @click="onPressedReceiveCallHistory()">รับงาน</vs-button>
              <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-x-circle"  class="btn-icon float-right" v-if="callHistoriesReceivedStatus === IStatus.enabled" @click="onPressedUnReceiveCallHistory()">ยกเลิกรับงาน</vs-button>
            </p>
          </vs-alert>
        </div>
      </div>
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="callHistories">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0" :class="{ 'pb-8': !visibilityAddCallHistoryButton }">
                <div class="vx-col w-1/2">
                  <h6>ข้อมูลการโทร</h6>
                </div>
                <div class="vx-col w-1/2 flex justify-end m-0 p-0">
                  <div class="flex">
                    <div class="mr-1 flex-1">
                      <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"  @click="onPressedActiveCallHistoryModal()" class="mb-1" v-if="visibilityAddCallHistoryButton">เพิ่มข้อมูล</vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th>ครั้งที่</vs-th>
              <vs-th>วันที่โทร</vs-th>
              <vs-th>หมายเหตุ</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.callDateLocalTh }}</vs-td>
                <vs-td>{{ row.remark }}</vs-td>
                <vs-td>{{ row.createdByFullName }}<br>{{ row.createdAtDateTimeLocalTh }}</vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                    <vx-tooltip text="ลบข้อมูลการโทร">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="onPressedDelCallHistory(row.id)" v-if="visibilityDelCallHistoryButton"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
    <vs-popup
      :active.sync="callHistoryModal.active"
      title="เพิ่มข้อมูลการโทร"
      class="custom-popup"
    >
      <div class="popup-content">
        <vs-textarea  v-model="callHistoryModal.remark" rows="5"/>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddCallHistory">บันทึก</vs-button>
        <vs-button color="danger" @click="callHistoryModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import {createNamespacedHelpers, mapState} from "vuex";
import {IStatus} from "@/constants/interface";
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'CallHistoryTab',
  components: {Divider},
  data() {
    return {
      callHistoryModal: {
        active: false,
        remark: "",
      },
    };
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapAccountingFields(['contractDetail', 'contractDetailCallHistories']),
    IStatus() {
      return IStatus
    },
    callHistories() {
      if (!this.contractDetailCallHistories) return null;
      return [... this.contractDetailCallHistories]
        .sort(({createdAt: aCreatedAt}, {createdAt: bCreatedAt}) => new Date(bCreatedAt) - new Date(aCreatedAt))
        .map((callHistory) => {
        const {
          id,
          seq,
          callDate,
          remark,
          status,
          callDateLocalTh,
          createdAtDateTimeLocalTh,
          createdByFullName,
        } = callHistory;
        return {
          id,
          seq,
          callDate,
          remark,
          status,
          callDateLocalTh,
          createdAtDateTimeLocalTh,
          createdByFullName,
        }
      })
    },
    callHistoriesReceivedStatus(){
      if(!this.contractDetail) return null;
      const { callHistoriesReceivedStatus } = this.contractDetail;
      return callHistoriesReceivedStatus
    },
    receivedSuggestion(){
      if(!this.contractDetail) return "";
      const {
        callHistoriesReceivedStatus,
        callHistoriesReceivedAtDateTimeLocalTh,
        callHistoriesReceivedBy
      } = this.contractDetail;
      if(callHistoriesReceivedStatus === IStatus.disabled){
        return "กรุณารับงานเพื่อดำเนินการติดตามงานดังกล่าว"
      }else {
        const callHistoriesReceivedByFullName = callHistoriesReceivedBy ? callHistoriesReceivedBy.fullName : "";
        return `${callHistoriesReceivedByFullName} กำลังติดตามงานดังกล่าว วันที่ ${callHistoriesReceivedAtDateTimeLocalTh}`
      }
    },
    visibilityAddCallHistoryButton(){
      if(!this.contractDetail) return false;
      const {  callHistoriesReceivedBy } = this.contractDetail;
      const callHistoriesReceivedById = callHistoriesReceivedBy ? callHistoriesReceivedBy.id : null;
      return callHistoriesReceivedById !== null && callHistoriesReceivedById === this.currentUser.id
    },
    visibilityDelCallHistoryButton(){
      if(!this.contractDetail) return false;
      const {  callHistoriesReceivedBy } = this.contractDetail;
      const callHistoriesReceivedById = callHistoriesReceivedBy ? callHistoriesReceivedBy.id : null;
      return callHistoriesReceivedById !== null && callHistoriesReceivedById === this.currentUser.id
    },
  },
  methods: {
    ...mapAccountingActions([
      'createContractDetailCallHistory',
      'deleteContractDetailCallHistory',
      'receiveContractDetailCallHistory',
      'unReceiveContractDetailCallHistory',
    ]),
    async onPressedReceiveCallHistory(){
      const { id:contractId } = this.$route.params;
      await this.receiveContractDetailCallHistory({
        id: contractId,
      })
    },
    async onPressedUnReceiveCallHistory(){
      const { id:contractId } = this.$route.params;
      await this.unReceiveContractDetailCallHistory({
        id: contractId,
      })
    },
    async onPressedActiveCallHistoryModal() {
      this.callHistoryModal.active = true
    },
    async onPressedAcceptAddCallHistory() {
      const vm = this
      const contractId  = this.$route.params.id;
      const {createContractDetailCallHistory} = vm;
      await createContractDetailCallHistory({
        contractId,
        form:{
          remark: vm.callHistoryModal.remark,
        }
      })
      vm.callHistoryModal.active = false;
      vm.callHistoryModal.remark = "";
    },
    async onPressedDelCallHistory(id) {
      const vm = this
      const { deleteContractDetailCallHistory } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailCallHistory({
            id,
            vm
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}
.col-createdBy {
  width: 200px;
}
.col-actions {
  width: 150px;
}

.custom-popup .vs-popup {
  width: 600px;
}
.popup-content {
  padding: 10px;
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
